<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
							<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
							</div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>
							<!-- Start Modal Body -->
							<div class="modal-body" style="min-height:60vh">
								<h4 class="title">Pilih SPK</h4>
								<div>
									<div class="row pl-3 pr-3">
										<div class="col-6">
											<h5>No SPK Asuransi :</h5>
										</div>
										<div class="col-6">
											{{ no_spk }}
										</div>
									</div>

									<div class="pl-3 pr-3">
										<h5 class="mt-2">Dokumen Tersedia</h5>

										<table
											class="table table-bordered text-center"
										>
											<thead class="thead-dark">
												<th>No.</th>
												<th>Nama Dokumen</th>
												<th>Tipe Dokumen</th>
												<th>Tanggal Unggah</th>
												<th>
													<i class="fa fa-eye"></i>
												</th>
												<th>
													<i class="fa fa-cog"></i>
												</th>
											</thead>
											<tbody
												v-for="(spk_document,
												index) in spk_documents_parsed"
												:key="index"
												:class="{'bg-yellow' : selectedSPK == spk_document.id}"
											>
												<tr
													style="vertical-align:middle;"
												>
													<td>{{ index + 1 }}</td>
													<td>
														{{ spk_document.name }}
													</td>
													<td>
														{{ spk_document.type }}
													</td>
													<td>
														{{
															moment(
																spk_document.timeOfUpload
															).format(
																"DD MMM Y hh:mm A"
															)
														}}
													</td>
													<td>
														<button
															class="btn btn-info"
															@click="
																openDocument(
																	spk_document.name
																)
															"
														>
															Liat Dokumen
														</button>
													</td>
													<td>
														<button
															class="btn btn-success"
															@click="
																highlightSPK(
																	spk_document.id
																)
															"
														>
															Pilih Dokumen
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>

									<div v-if="status == 'Supplied'">
										<div class="input-group">
											<label class="label">Tanggal Janji Sparepart Datang</label>
											<!-- <input type="text" class="input--style-4" v-model="no_resi" placeholder="Ketik Nomor Resi"/> -->
											<Datepicker input-class="input--style-4" class="w-100" type="text" name="policy_expiry" v-model="date" placeholder="Isi Tanggal"/>
										</div>

										<div class="input-group">
											<label class="label">Input Supplier</label>
											<!-- <input type="text" class="input--style-4" v-model="no_resi" placeholder="Ketik Nomor Resi"/> -->
											<Multiselect 
												v-if="supplierList"
												:disabled="noSupplier"
												:options="supplierList.map(x => x.id)"
												:custom-label="opt => supplierList.find(x => opt == x.id).name"
												v-model="supplier"
												placeholder="Isi Supplier"
											/>



											
										</div>
										<div class="row row-space mb-3">
											<div
												class="form-check form-check-inline col-12"
											>
												<input
													class="form-check-input"
													style="width:15%"
													type="checkbox"
													id="inlineCheckbox1"
													value="option1"
													v-model="noSupplier"
												/>
												<label
													class="form-check-label"
													for="inlineCheckbox1"
													>Supplier Tidak Diketahui</label
												>
											</div>
										</div>
										<button class="btn btn-info ml-4 mb-2" @click="showAddSupplier = true">
											Add New Supplier
										</button>

										<div v-if="showAddSupplier" class="border border-secondary rounded p-10">
											<h3 class="text-center">New Supplier</h3>
											<NewSupplier 
												@closeModal="showAddSupplier = false"
												@supplierData="selectSupplier"
											/>
										</div>
									</div>

									<div v-else-if="status == 'Approved' && selectedData.sparepart_type == 'P'">
										<!-- <div class="input-group pb-0" >
											<label class="label">Harga Modal Sparepart : Rp. {{numberWithCommas(this.selectedData.price_modal)}}</label>
										</div>
										<div class="input-group pb-0" >
											<label class="label">Harga Modal Sparepart : Rp. {{this.selectedData.supplier_price}}</label>
										</div> -->
										<div class="pl-3 pr-3">
											<table class="table mt-3 mb-3 table-bordered">
												<thead class="thead-dark">
													<th>Harga Modal Sparepart</th>
													<th>Harga Pricelist Sparepart</th>
												</thead>
												<tbody>
													<tr>
														<td>Rp. {{numberWithCommas(this.selectedData.price_modal)}}</td>
														<td>Rp. {{this.selectedData.supplier_price}}</td>
													</tr>
												</tbody>
											</table>
										</div>
										<div class="input-group pt-0">
											<label class="label">Harga Yang Akan Ditagih Ke Asuransi</label>
											<input type="text" class="input--style-4" v-model="curPrice" placeholder="Isi Harga"/>
											<!-- <Datepicker input-class="input--style-4" class="w-100" type="text" name="policy_expiry" v-model="date" placeholder="Isi Tanggal"/> -->
										</div>
										<div class="input-group pt-0">
											<div
												class="form-check form-check-inline"
											>
												<input
													class="form-check-input ml-1"
													style="width:20%"
													type="checkbox"
													id="inlineCheckbox2"
													value="option1"
													disabled
													v-model="tambahPPN"
												/>
												<label
													class="form-check-label ml-3"
													for="inlineCheckbox1"
													style="min-width:150px"
													>Tambah PPN</label
												>
											</div>
										</div>
									</div>

									<br />
									<div class="row">
										<div
											class="col mt-5"
											style="text-align: center"
										>
											
											<button
												type="button"
												class="btn btn-outline-danger"
												style="font-size:140%"
												@click="$emit('closeModal')"
											>
												Kembali
											</button>
											<button
												type="button"
												class="btn btn-outline-primary ml-4"
												style="font-size:140%"
												@click="selectSPK"
											>
												Selesai
											</button>
										</div>
									</div>
								</div>
							</div>
							<!-- End Modal Body -->
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import moment from "moment";
import env from "@/env";
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import NewSupplier from './newSupplier.vue'

export default {
	components : {
		Datepicker,
		Multiselect,
		NewSupplier
	},
	data() {
		return {
			no_spk: this.data.details.no_spk,
			no_spk_temp: "",
			file: null,
			spk_documents_parsed: [],
			moment: moment,
			date : null,
			supplier : null,
			supplierList : [],
			showAddSupplier : false,
			selectedSPK : null,
			selectedData : null,
			curPrice : 0,
			noSupplier : false,
			tambahPPN : true
		};
	},
	watch : {
		curPrice : function () {
			const result = this.curPrice.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.curPrice = result);
		}
	},
	mounted() {
		this.data[this.variable] = parseInt(this.data[this.variable]);
		this.parseSPK();

		this.supplierList = this.loadSupplierList()

		this.selectedData = this.data.estimations.find(x => x.id == this.dataSelect.id)

		if(this.selectedData.estimated_price)
			this.curPrice = this.selectedData.estimated_price
	},
	methods: {
		loadSupplierList () {
			this.$http.get('/api/v1/masterData/supplier?pagination=false')
			.then((resp) => {
				this.supplierList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		selectSupplier (supplier) {
			// console.log(supplier)
			this.loadSupplierList()
			this.supplier = supplier.id
		},
		openDocument(url) {
			window.open(`${env.baseImage}/${url}`, "_blank");
		},
		parseSPK() {
			for (var i = 0; i < this.spk_documents.length; i++) {
				let obj = {};

				let splitName = this.spk_documents[i].file.split("/");
				obj.name = splitName[splitName.length - 1];
				obj.id = this.spk_documents[i].id;
				obj.type = this.spk_documents[i].spk_type;

				// obj.timeOfUpload = obj.name.split(' - ')[1].replace('.pdf', '')
				obj.link = this.spk_documents[i].file;

				this.spk_documents_parsed.push(obj);
			}
		},
		highlightSPK(spk_id) {
			this.selectedSPK = spk_id
		},

		selectSPK() {
			if(!this.selectedSPK) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Dipilih Dokumen SPK Terlebih Dahulu.'])
				return
			}

			if(this.status == 'Supplied' && !this.date) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi tanggal janji datang sparepart.'])
				return
			}

			else if(this.status == 'Supplied' && !this.supplier && !this.noSupplier) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi supplier sparepart atau isi Supplier Tidak Diketahui.'])
				return
			}

			if(this.status == 'Approved' && this.selectedData.sparepart_type == 'P' && this.curPrice == 0) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi harga yang akan ditagih.'])
				return
			}
			else if(this.status == 'Approved' && this.selectedData.sparepart_type == 'P' && this.curPrice != 0) {
				this.selectedData.markup = parseInt(this.curPrice.split(',').join('')) - this.selectedData.price_modal
				console.log(this.selectedData.markup, this.curPrice , this.dataSelect.price / this.selectedData.amount)
				this.updateSupplierPriceId(this.selectedData.markup)
			}
			



			this.$emit(
				"updateStatusEstimation",
				this.dataSelect.status,
				this.dataSelect.index,
				this.dataSelect.id,
				this.selectedSPK,
				this.dataSelect.price / this.selectedData.amount,
				{
					supplier : this.supplier,
					date : this.date,
					markup : this.selectedData.markup
				}
			);
		},
		updateSupplierPriceId (markup) {
			this.$http.patch('/api/v1/estimations/' + this.selectedData.id , {markup : markup , ppn : this.tambahPPN})
			.then((resp) => {
				console.log(resp.data.data)
			})
			.catch((err) => {
				console.log(err)
			}) 
		}
	},
	props: [
		"data",
		"type",
		"variable",
		"form_code",
		"spk_documents",
		"dataSelect",
		"status",
	],
};
</script>

<style>
/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

/* FILE DRAG N' DROP START */
.dropZone {
	/* width: 80%; */
	height: 200px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone:hover {
	border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
	color: #1975a0;
}

.dropZone-info {
	color: #a8a8a8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.dropZone-title {
	color: #787878;
}

.dropZone input {
	position: absolute;
	cursor: pointer;
	top: 0px;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
}

.dropZone-upload-limit-info {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
}

.dropZone-over {
	background: #5c5c5c;
	opacity: 0.8;
}

.dropZone-uploaded {
	/* width: 80%; */
	height: 200px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone-uploaded-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #a8a8a8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.removeFile {
	width: 200px;
}
/* FILE DRAG N' DROP END */
</style>
